/** 2026-07-22 → 22/07/2026; lascia invariato ciò che non è una data ISO. */
export function formatItalianDate(value: string | null | undefined): string {
  if (!value) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : value;
}

const LOWERCASE_WORDS = new Set(["ved", "ved.", "vedova", "vedovo", "in", "e"]);

/** I portali scrivono i nomi a volte tutti maiuscoli, a volte no: per leggere
 * la lista li riportiamo a "Maria Rosa Rossi". I nomi già con minuscole
 * restano come li ha scritti la fonte. */
export function personName(value: string | null | undefined): string {
  const raw = value?.trim();
  if (!raw) return "—";
  if (/\p{Ll}/u.test(raw)) return raw;
  return raw
    .toLocaleLowerCase("it-IT")
    .split(/\s+/)
    .map((word, i) => {
      if (i > 0 && LOWERCASE_WORDS.has(word)) return word;
      return word.replace(/(^|['’\-(])(\p{L})/gu, (_, sep: string, ch: string) => sep + ch.toLocaleUpperCase("it-IT"));
    })
    .join(" ");
}
